import React from "react"

export const A = ({ children, href }) => {
  return (
    <>
      {" "}
      <a className="link" target="__blank" href={href}>
        {children}
      </a>{" "}
    </>
  )
}
